import { useEffect, useMemo, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { DOCTOR_CLINIC_ROUTER_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import zoneLocalStorageId from "utils/zone";
import Loader from "components/Common/loader";
import {
  createDoctorClinicRouter,
  updateDoctorClinicRouter,
} from "services/doctorClinicRouter";
import { useSelector } from "react-redux";

const AddDoctorClinicRouter = ({ onClose, rowData }) => {
  const {
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => rowData, [rowData]),
  });

  const { user } = useSelector((state) => state.jwtAuthreducer);

  console.log("user", user);

  const { showAlert } = useAlert();

  const onSuccess = () => {
    const shouldRefetch = true;

    const message = rowData
      ? "Doctor Clinic Router updated successfully!"
      : "Doctor Clinic Router created successfully!";

    showAlert(message, "success");
    onClose(shouldRefetch);
  };

  const onError = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;

    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: createRouter, isLoading: isCreating } = useMutation({
    mutationFn: createDoctorClinicRouter,
    onSuccess,
    onError,
  });

  const { mutate: updateRouter, isLoading: isUpdating } = useMutation({
    mutationFn: updateDoctorClinicRouter,
    onSuccess,
    onError,
  });

  const isSubmitting = isCreating || isUpdating;

  const handleSubmitRouter = (values, e) => {
    e.preventDefault();

    const payload = {
      clinic_name: values?.clinic_name,
      clinic_address: values?.clinic_address,
      zone_id: values?.zone_id || zoneLocalStorageId(),
      created_by:
        user?.employee_code_id || localStorage.get("employee_code_id"),
      is_active: values?.is_active ?? true,
    };

    if (rowData) {
      updateRouter({
        id: rowData?.id,
        ...payload,
      });
    } else {
      createRouter(payload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading={true} />
        </div>
      )}

      <CustomForm
        config={DOCTOR_CLINIC_ROUTER_FORM_CONFIG(rowData)}
        onSubmit={handleSubmitRouter}
        columnCount={1}
        rowData={rowData}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddDoctorClinicRouter;
